export default () => `
<div class="small-container1 ">
        <div class="row1 row2">
            <h2>All Women Products</h2>
            <select class="select">
            <option value="select-price-low" id="disabled">Sort</option>
            <option value="select-price-low">Price (Low-High)</option>
            <option value="select-price-high">Price (High-Low)</option>
             </select>
        </div>
        <div class="row1 products-center">
        </div>
            <div class="pages-btn">
            <span>1</span>
            <span id="disabled-span">→</span>
            </div>
            </div>
            `;
